import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedCustomer: '',
    selectedClient: '',
    formData: ''
}

const uploadTbSlice = createSlice({
    name: 'uploadTbSlice',
    initialState,
    reducers: {
        setSelectedCustomer: (state, action) => {
            state.selectedCustomer = action.payload
        },
        setSelectedClient: (state, action) => {
            state.selectedClient = action.payload
        },
        setFormData: (state, action) => {
            state.formData = action.payload
        }
    }
})

export const {setSelectedCustomer, setSelectedClient, setFormData} = uploadTbSlice.actions;

export default uploadTbSlice;